<template>
  <div :class="componentClassName">
    <div class="a-find-in-page-search-spaceline"></div>
    <div class="a-find-in-page-search-box">
      <input
        id="a-find-in-page-search-input"
        v-model="keyword"
        type="text"
        class="a-find-in-page-search-text"
        :disabled="disabled"
        placeholder="テキスト検索"
        @input="onInput"
        @keypress.enter="onMove('next')"
      />
      <div class="a-find-in-page-search-buttons">
        <a-button
          id="a-find-in-page-search-prev"
          :inline="true"
          variant="round"
          :color="disabled === 'disabled' ? 'grey' : 'white'"
          :disabled="disabled === 'disabled'"
          size="small"
          label="前へ"
          @click="onMove('prev')"
        />
        <a-button
          id="a-find-in-page-search-next"
          :inline="true"
          variant="round"
          :color="disabled === 'disabled' ? 'grey' : 'white'"
          :disabled="disabled === 'disabled'"
          size="small"
          label="次へ"
          @click="onMove('next')"
        />
      </div>
      <br />
      <div class="a-find-in-page-search-hilights-length">
        <div v-if="hasHighlight">
          <span v-text="highlightIndex + 1"></span> / <span v-text="highlights.length"></span>
        </div>
      </div>
    </div>
    <div class="a-find-in-page-search-spaceline"></div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import { ref, nextTick } from 'vue';

export default {
  name: 'a-find-in-page-search',
  components: {},
  props: {
    class: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: '',
    },
    disabled: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  setup() {
    return {
      container: ref(null),
    };
  },
  data() {
    return {
      keyword: '',
      highlights: [],
      highlightIndex: -1,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-find-in-page-search');
      return `${baseClassName} ${this.class}`.trim();
    },
    hasHighlight() {
      return this.highlights.length > 0;
    },
  },
  watch: {
    modelValue: {
      // 2-3: キーワードが変更になったら必ず全てのハイライト部分を取得するようにする
      immediate: true,
      handler(value) {
        this.keyword = value;

        nextTick(() => {
          this.highlights = document.querySelectorAll('.a-find-in-page-content-highlight');
        });
      },
    },
  },
  methods: {
    onInput() {
      // 2-1: 検索キーワードが変更になったら v-model に伝える
      this.highlightIndex = -1;
      this.$emit('update:modelValue', this.keyword);
    },
    onMove(direction) {
      // 2-2: 該当する部分の色を変え、スクロール位置を自動で変更する
      if (this.highlights.length > 0) {
        let targetIndex = this.highlightIndex;
        const maxIndex = this.highlights.length - 1;

        if (direction === 'prev') {
          targetIndex--;

          if (targetIndex < 0) {
            targetIndex = maxIndex;
          }
        } else if (direction === 'next') {
          targetIndex++;

          if (targetIndex > maxIndex) {
            targetIndex = 0;
          }
        }

        this.highlightIndex = targetIndex;

        for (let i = 0; i < this.highlights.length; i++) {
          const target = this.highlights[i];
          target.classList.remove('a-find-in-page-search-word');
          target.classList.remove('a-find-in-page-search-other-word');
          if (i === targetIndex) {
            // ヒットしているワード群の次のワードの色を変える
            target.classList.add('a-find-in-page-search-word');
            // 次のワードにスクロールしている
            document.getElementsByClassName('a-find-in-page-search-word')[0].scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          } else {
            target.classList.add('a-find-in-page-search-other-word');
          }
        }
      }
    },
  },
};
</script>
